﻿/*
 * Globalize Culture vi-VN
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("vi-VN", "default", {
    name: "vi-VN",
    englishName: "Vietnamese (Vietnam)",
    nativeName: "Tiếng Việt (Việt Nam)",
    language: "vi",
    numberFormat: {
      ",": ".",
      ".": ",",
      percent: {
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": ".",
        ".": ",",
        symbol: "₫"
      }
    },
    calendars: {
      standard: {
        firstDay: 1,
        days: {
          names: [
            "Chủ Nhật",
            "Thứ Hai",
            "Thứ Ba",
            "Thứ Tư",
            "Thứ Năm",
            "Thứ Sáu",
            "Thứ Bảy"
          ],
          namesAbbr: ["CN", "Hai", "Ba", "Tư", "Năm", "Sáu", "Bảy"],
          namesShort: ["C", "H", "B", "T", "N", "S", "B"]
        },
        months: {
          names: [
            "Tháng Giêng",
            "Tháng Hai",
            "Tháng Ba",
            "Tháng Tư",
            "Tháng Năm",
            "Tháng Sáu",
            "Tháng Bảy",
            "Tháng Tám",
            "Tháng Chín",
            "Tháng Mười",
            "Tháng Mười Một",
            "Tháng Mười Hai",
            ""
          ],
          namesAbbr: [
            "Thg1",
            "Thg2",
            "Thg3",
            "Thg4",
            "Thg5",
            "Thg6",
            "Thg7",
            "Thg8",
            "Thg9",
            "Thg10",
            "Thg11",
            "Thg12",
            ""
          ]
        },
        AM: ["SA", "sa", "SA"],
        PM: ["CH", "ch", "CH"],
        patterns: {
          d: "dd/MM/yyyy",
          D: "dd MMMM yyyy",
          f: "dd MMMM yyyy h:mm tt",
          F: "dd MMMM yyyy h:mm:ss tt",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Trợ giúp bổ sung",
      AddNewTab: "Thêm tab mới",
      Alerts: "Cảnh báo",
      ApplyFilter: "Áp dụng bộ lọc",
      Approve: "Chấp thuận",
      Attachments: "Tệp đính kèm",
      Back: "Lùi",
      Basic: "Cơ bản",
      Between: "Giữa",
      Book: "Sách",
      Cancel: "Hủy bỏ",
      Checked: "Đã đánh dấu",
      ClearFilter: "Xóa bộ lọc",
      Close: "Đóng",
      CloseCancelChanges: "Đóng và hủy bỏ các thay đổi",
      CloseSaveChanges: "Đóng và lưu các thay đổi",
      CloseTab: "Đóng tab",
      ColumnPersonalization: "Cá nhân hóa cột",
      Comments: "Chú thích",
      Confirmation: "Xác nhận",
      Contains: "Có chứa",
      CreateTab: "Tạo tab mới",
      Cut: "Cắt",
      Delete: "Xóa",
      DiscardUndo: "Bỏ/Hoàn tác",
      DisplayDropDownList: "Hiển thị danh sách thả xuống",
      Displaying: "Đang hiển thị: ",
      DocWord: "Tài liệu",
      DoesNotContain: "Không chứa",
      DoesNotEndWith: "Không kết thúc bằng",
      DoesNotEqual: "Không bằng",
      DoesNotStartWith: "Không bắt đầu với",
      Download: "Tải xuống",
      Duplicate: "Trùng lặp",
      Edit: "Sửa",
      EitherSelectedorNotSelected: "Hoặc được chọn hoặc không được chọn",
      Email: "Email",
      EndsWith: "Kết thúc bằng",
      EqualsStr: "Bằng",
      ExpandCollapse: "Mở rộng/Thu gọn",
      ExportFailed: "Xuất không thành công",
      ExportToExcel: "Xuất sang Excel",
      FileInUse: "Tệp xác định đang được sử dụng",
      FileInUseDetail:
        "Đóng tệp trong ứng dụng nơi nó đang được sử dụng hoặc xác định một tên tệp khác.",
      Filter: "Lọc",
      FilterMenu: "Menu bộ lọc",
      FilterOptions: "Tùy chọn bộ lọc",
      FilterWithinResults: "Lọc trong các kết quả",
      First: "Đầu tiên",
      FirstView: "Dạng xem đầu tiên",
      Folder: "Thư mục",
      ForgotPassword: "Bạn quên mật khẩu?",
      Forward: "Chuyển tiếp",
      GetMoreRows: "Lấy thêm hàng",
      GreaterThan: "Lớn hơn",
      GreaterThanOrEquals: "Lớn hơn hoặc bằng",
      GridSettings: "Thiết đặt lưới",
      GroupSelection: "Lựa chọn nhóm",
      Help: "Trợ giúp",
      HideColumn: "Cột ẩn",
      IsEmpty: "Đang trống",
      IsNotEmpty: "Không trống",
      Last: "Cuối cùng",
      LastView: "Dạng xem cuối cùng",
      LaunchActivate: "Khởi chạy/Kích hoạt",
      LessThan: "Ít hơn",
      LessThanOrEquals: "Ít hơn hoặc bằng",
      Links: "Liên kết",
      ListTabs: "Liệt kê tất cả các tab",
      LoadingItem: "Đang tải mục ",
      Maintenance: "Bảo trì",
      Menu: "Menu",
      New: "Mới",
      Next: "Tiếp theo",
      NextView: "Dạng xem tiếp theo",
      No: "Không",
      NotChecked: "Không được đánh dấu",
      Notes: "Ghi chú",
      NotSelected: "Không được chọn",
      Of: " của ",
      Ok: "OK",
      Open: "Mở",
      Password: "Mật khẩu",
      Paste: "Dán",
      Phone: "Điện thoại",
      PleaseWait: "Vui lòng chờ",
      Previous: "Trước",
      PreviousView: "Dạng xem trước",
      Print: "In",
      Queries: "Truy vấn",
      Redo: "Làm lại",
      Refresh: "Làm mới",
      Reject: "Từ chối",
      RememberMe: "Ghi nhớ tôi trên máy tính này",
      Reports: "Báo cáo",
      Reset: "Đặt lại",
      Review: "Xem lại",
      RunFilter: "Chạy bộ lọc",
      RunJob: "Chạy tác vụ",
      Save: "Lưu",
      SaveBeforeClosing: "Lưu trước khi đóng",
      SavedFilters: "Bộ lọc đã lưu",
      SaveSubmit: "Lưu/Gửi",
      ScreenDesign: "Thiết kế màn hình",
      Search: "Tìm kiếm",
      SelectContents: "Chọn nội dung",
      SelectDate: "Chọn một ngày",
      SelectDeselect: "Chọn / Bỏ chọn tất cả",
      Selected: "Được chọn: ",
      ServerName: "Tên máy chủ",
      Settings: "Thiết đặt",
      ShowFilterRow: "Hiển thị dòng bộ lọc",
      SignIn: "Đăng nhập",
      SortAscending: "Sắp xếp tăng dần",
      SortDescending: "Sắp xếp giảm dần",
      Spreadsheet: "Bảng tính",
      StartsWith: "Bắt đầu với",
      StatusIndicator: "Chỉ báo trạng thái",
      Tasks: "Nhiệm vụ",
      Today: "Hôm nay",
      Translate: "Dịch",
      UserID: "ID người dùng",
      Utilities: "Tiện ích",
      Yes: "Có",
      Page: "Trang",
      Rows: "Hàng",
      ShowingAll: "Hiện tất cả",
      SessionNavigation: "Dẫn hướng theo phiên làm việc",
      ListAllMenuItems: "Liệt kê tất cả mục menu",
      NoRecordsFound: "Không tìm thấy bản ghi",
      SearchTree: "Tìm kiếm cây",
      Clear: "Xóa",
      DrillDown: "Truy sâu xuống",
      Required: "Trường này là bắt buộc",
      Available: "Sẵn có:",
      Add: "Thêm",
      MoveDown: "Di chuyển xuống",
      MoveUp: "Di chuyển lên",
      Remove: "Loại bỏ",
      LastYear: "Năm ngoái",
      NextMonth: "Tháng sau",
      NextWeek: "Tuần sau",
      NextYear: "Năm sau",
      OneMonthAgo: "Một tháng trước",
      OneWeekAgo: "Một tuần trước",
      SixMonthsAgo: "Sáu tháng trước",
      Time: "Thời gian",
      CannotBeSelected: "Không chọn được hàng này.",
      ResetToDefault: "Đặt lại về bố trí mặc định",
      CloseOtherTabs: "Đóng các tab khác",
      EmailValidation: "Hãy nhập địa chỉ e-mail hợp lệ",
      UrlValidation: "Hãy nhập URL hợp lệ",
      EndofResults: "Cuối kết quả",
      More: "Thêm...",
      RecordsPerPage: "Số bản ghi mỗi trang",
      Maximize: "Tối đa hóa",
      Minimize: "Giảm thiểu"
    }
  });
})(this);
